import { IconNodeInfo } from "./SWIconNode";
import { ImgNodeInfo } from "./SWImgNode";
import { LottieNodeInfo } from "./SWLottieNode";
import { NavigationNodeInfo } from "./SWNavigationNode";
import { TextNodeInfo } from "./SWTextNode";
import { VideoNodeInfo } from "./SWVideoNode";
import { StackNodeInfo } from "./SWStackNode";
import { DrawerNodeInfo } from "./SWDrawerNode";
import { InputNodeInfo } from "./SWInputNode";
export const NodeMap = {
    img: ImgNodeInfo,
    text: TextNodeInfo,
    video: VideoNodeInfo,
    lottie: LottieNodeInfo,
    icon: IconNodeInfo,
    stack: StackNodeInfo,
    navigation: NavigationNodeInfo,
    drawer: DrawerNodeInfo,
    input: InputNodeInfo
};
